import { api } from "@/services/api/createAPI";
import { getAuthToken } from "@/services/supabase/auth/actions/getAuthToken";
import { SemanticModel } from "@pufflig/prompt-studio-types";
import { useQueryClient } from "@tanstack/react-query";

export const getConnectorSchema = async (connectorId: string) => {
  const apiKey = await getAuthToken();
  const { data } = await api(apiKey).post("/api/sql/db_schema", { connectorId });

  if (!data) {
    return null;
  }

  return data.schema;
};

export const useConnectorSchema = () => {
  const queryClient = useQueryClient();

  return async (connectorId: string) => {
    const queryKey = ["connector_schema", connectorId];
    const cached = queryClient.getQueryData<SemanticModel>(queryKey);

    if (cached) {
      return cached;
    }

    const data: SemanticModel = await getConnectorSchema(connectorId);
    queryClient.setQueryData(queryKey, data);

    return data;
  };
};
